/* Surrani theme — small, dependency-free behaviour. */
(function () {
  'use strict';
  var T = window.SurraniTheme || { routes: {}, strings: {} };
  var S = T.strings;

  /* ---------- helpers ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function setCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    qsa('[data-cart-link]').forEach(function (el) {
      var label = el.getAttribute('aria-label') || '';
      el.setAttribute('aria-label', label.replace(/\d+/, count));
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || S.error);
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  /* Shopify's own messages (e.g. stock limits) carry a status; network failures do not. */
  function friendlyError(err) {
    return (err && err.status && err.message) ? err.message : S.error;
  }

  /* One cart request at a time, so rapid taps cannot conflict. */
  var queue = Promise.resolve();
  function enqueue(fn) {
    var run = queue.then(fn, fn);
    queue = run.catch(function () {});
    return run;
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function showToast(msg) {
    var toast = qs('#CartToast');
    if (!toast) return;
    qs('[data-toast-msg]', toast).textContent = msg;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 6000);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) { var t = qs('#CartToast'); if (t) t.hidden = true; }
  });

  /* ---------- details: close on outside click / Escape / close button ---------- */
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-details-close]');
    if (closeBtn) { var d = closeBtn.closest('details'); if (d) d.removeAttribute('open'); return; }
    qsa('details[data-close-outside][open]').forEach(function (d) {
      if (d.classList.contains('drawer')) {
        /* The dimmed backdrop belongs to the <details> element itself. */
        if (e.target === d) d.removeAttribute('open');
      } else if (!d.contains(e.target)) {
        d.removeAttribute('open');
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('details[open]').forEach(function (d) {
      if (d.matches('[data-close-outside]')) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); }
    });
  });
  qsa('details.search-pop').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) { var i = d.querySelector('input[type=search]'); if (i) setTimeout(function () { i.focus(); }, 30); } });
  });
  qsa('details.drawer').forEach(function (d) {
    d.addEventListener('toggle', function () { document.documentElement.style.overflow = d.open ? 'hidden' : ''; });
  });

  /* ---------- announcement rotator (phones only) ---------- */
  qsa('[data-announce]').forEach(function (bar) {
    var items = qsa('.announce__item', bar);
    if (items.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      if (window.innerWidth >= 990 || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- quantity +/- on product page ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = btn.hasAttribute('data-qty-plus') ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  /* ---------- product page ---------- */
  qsa('[data-product]').forEach(function (root) {
    var form = qs('[data-product-form]', root);
    var picker = qs('[data-variant-picker]', root);
    var addBtn = qs('[data-add-button]', root);
    var addLabel = qs('[data-add-label]', root);
    var stickyBtn = qs('[data-sticky-add]', root);
    var stickyPrice = qs('[data-sticky-price]', root);
    var errorEl = qs('[data-form-error]', root);
    var variants = [];
    if (picker) {
      try { variants = JSON.parse(qs('[data-variants]', picker).textContent); } catch (err) { variants = []; }
    }

    function setButtons(available, exists) {
      var label = !exists ? S.unavailable : (available ? S.addToCart : S.soldOut);
      [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !(exists && available); });
      if (addLabel) addLabel.textContent = label;
      if (stickyBtn) stickyBtn.textContent = label;
      var dyn = qs('.buy__dynamic', root);
      if (dyn) dyn.hidden = !(exists && available);
    }

    function selectedOptions() {
      var groups = qsa('.variants__group', picker);
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }

    function markAvailability(selected) {
      qsa('.variants__group', picker).forEach(function (g, gi) {
        qsa('.variants__input', g).forEach(function (input) {
          var opts = selected.slice(); opts[gi] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (o, k) { return o === opts[k]; }); });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function onChange() {
      var selected = selectedOptions();
      selected.forEach(function (val, i) { var span = qs('[data-option-value="' + i + '"]', picker); if (span) span.textContent = val; });
      var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === selected[k]; }); });
      markAvailability(selected);
      if (!v) { setButtons(false, false); return; }
      qs('[data-variant-id]', form).value = v.id;
      var price = qs('[data-price]', root);
      if (price) {
        qs('[data-price-current]', price).textContent = v.price;
        var cmpWrap = qs('.price__compare', price);
        if (cmpWrap) { cmpWrap.hidden = !v.compare; if (v.compare) qs('[data-price-compare]', price).textContent = v.compare; }
        price.classList.toggle('price--sale', !!v.compare);
      }
      if (stickyPrice) stickyPrice.textContent = v.price;
      setButtons(v.available, true);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.media) {
        var slide = qs('[data-media-id="' + v.media + '"]', root);
        if (slide) scrollToSlide(slide);
      }
    }
    if (picker && variants.length) {
      picker.addEventListener('change', onChange);
      markAvailability(selectedOptions());
    }

    /* Add to cart via Ajax; falls back to normal form post without JS. */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        /* Ignore repeat taps while an add is in progress, so one tap = one bag. */
        if (form.getAttribute('data-busy') === 'true') return;
        form.setAttribute('data-busy', 'true');
        if (errorEl) errorEl.hidden = true;
        var fd = new FormData(form);
        var body = { items: [{ id: Number(fd.get('id')), quantity: Math.max(1, parseInt(fd.get('quantity') || '1', 10)) }] };
        [addBtn, stickyBtn].forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
        if (addLabel) addLabel.textContent = S.adding;
        enqueue(function () { return postJSON(T.routes.cartAdd, body); })
          .then(function () { return fetch(T.routes.cartJs, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (cart) {
            setCartCount(cart.item_count);
            if (T.afterAdd === 'cart') { window.location.href = T.routes.cart; return; }
            showToast(S.added);
          })
          .catch(function (err) {
            var t = qs('#CartToast'); if (t) t.hidden = true;
            if (errorEl) { errorEl.textContent = friendlyError(err); errorEl.hidden = false; }
          })
          .then(function () {
            form.removeAttribute('data-busy');
            [addBtn, stickyBtn].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
            if (addLabel && addBtn && !addBtn.disabled) addLabel.textContent = S.addToCart;
          });
      });
    }

    /* Gallery: dots on phones, thumbs on desktop */
    var track = qs('[data-gallery-track]', root);
    var dots = qsa('.gallery__dot', root);
    function scrollToSlide(slide) {
      if (!track) return;
      if (window.innerWidth >= 990) { slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      else { track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    }
    if (track && dots.length) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          ticking = false;
        });
      }, { passive: true });
    }

    /* Sticky add-to-cart bar on phones */
    var sticky = qs('[data-sticky-buy]', root);
    var buyBlock = qs('[data-buy]', root);
    if (sticky && buyBlock && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var footer = qs('.footer');
      var buyVisible = true, footerVisible = false;
      var update = function () {
        var on = !buyVisible && !footerVisible;
        sticky.classList.toggle('is-visible', on);
        /* Lets CSS lift floating chat buttons so they never cover the sticky Add to cart. */
        document.documentElement.classList.toggle('sticky-buy-on', on);
      };
      new IntersectionObserver(function (entries) { buyVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; update(); }).observe(buyBlock);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
    }
  });

  /* ---------- related products (loaded when near the viewport) ---------- */
  qsa('[data-recommendations]').forEach(function (el) {
    if (el.querySelector('.related__inner')) return;
    var load = function () {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.related__inner');
        if (inner) el.appendChild(inner);
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else { load(); }
  });

  /* ---------- collection: auto-submit sort ---------- */
  qsa('[data-auto-submit]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* ---------- cart page ---------- */
  /* Quantity taps update the box at once and every tap counts. Rapid taps are combined:
     only the latest quantity is sent, and the cart re-renders once nothing is pending,
     so totals never flash old numbers. Requests still go one at a time (enqueue). */
  function initCart() {
    var section = qs('[data-cart-section]');
    if (!section) return;
    var sectionId = section.getAttribute('data-cart-section');
    var desired = {}, timers = {}, inFlight = 0, lastData = null;

    function rowFor(key) { return section.querySelector('.citem[data-key="' + key + '"]'); }
    function pending() { return inFlight > 0 || Object.keys(desired).length > 0 || Object.keys(timers).length > 0; }
    function setUpdating() { section.classList.toggle('is-updating', pending()); }

    function render(data) {
      setCartCount(data.item_count);
      var html = data.sections && data.sections[sectionId];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-section]');
        if (fresh) { section.innerHTML = fresh.innerHTML; }
      }
      var st = qs('[data-cart-status]', section);
      if (st) st.textContent = S.updated;
    }

    /* Called after every request; renders the newest server cart once nothing else is pending. */
    function finish(errKey, err) {
      if (!pending() && lastData) { render(lastData); lastData = null; }
      if (errKey) {
        var row = rowFor(errKey);
        if (row) {
          row.classList.remove('is-loading', 'is-updating');
          var e = qs('[data-line-error]', row);
          if (e) { e.textContent = friendlyError(err); e.hidden = false; }
          var input = qs('[data-cart-qty]', row);
          if (input) input.value = input.defaultValue;
        }
      }
      setUpdating();
    }

    function send(key) {
      inFlight++;
      return enqueue(function () {
        if (!(key in desired)) return null;
        var q = desired[key];
        delete desired[key];
        return postJSON(T.routes.cartChange, { id: key, quantity: q, sections: [sectionId], sections_url: window.location.pathname });
      }).then(function (data) {
        inFlight--;
        if (data) lastData = data;
        finish();
      }).catch(function (err) {
        inFlight--;
        finish(key, err);
      });
    }

    /* delay: wait for more taps before sending (0 = send now) */
    function changeLine(key, quantity, row, delay) {
      desired[key] = quantity;
      if (row) {
        row.classList.add(quantity === 0 ? 'is-loading' : 'is-updating');
        var e = qs('[data-line-error]', row); if (e) e.hidden = true;
      }
      clearTimeout(timers[key]);
      if (delay) {
        timers[key] = setTimeout(function () { delete timers[key]; send(key); }, delay);
        setUpdating();
      } else {
        delete timers[key];
        setUpdating();
        send(key);
      }
    }

    section.addEventListener('click', function (e) {
      var row = e.target.closest('.citem');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var input = qs('[data-cart-qty]', row);
      if (e.target.closest('[data-cart-remove]')) { e.preventDefault(); changeLine(key, 0, row, 0); return; }
      var minus = e.target.closest('[data-cart-minus]');
      var plus = e.target.closest('[data-cart-plus]');
      if (!minus && !plus) return;
      var current = parseInt(input.value, 10) || 0;
      var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
      var next = plus ? Math.min(current + 1, max) : Math.max(current - 1, 0);
      if (next === current) {
        var errEl = qs('[data-line-error]', row);
        if (plus && errEl) { errEl.textContent = S.maxQty; errEl.hidden = false; }
        return;
      }
      input.value = next;
      changeLine(key, next, row, next === 0 ? 0 : 300);
    });

    section.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (input) {
        var row = input.closest('.citem');
        var q = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(row.getAttribute('data-key'), q, row, 0);
        return;
      }
      var note = e.target.closest('[data-cart-note]');
      if (note) { enqueue(function () { return postJSON(T.routes.cartUpdate, { note: note.value }); }); }
    });

    /* Prevent Enter in a quantity box from submitting to checkout */
    section.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-cart-qty]')) { e.preventDefault(); e.target.blur(); }
    });
  }
  initCart();
})();
